<template>
  <div class="modal fade" :id="id" tabindex="-1" aria-labelledby="resetModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="resetModalLabel">{{ $t("js.backend.reset_modal.header") }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body" v-html="$t('js.backend.reset_modal.body_html')"></div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">
            {{ $t("js.actions.cancel") }}
          </button>
          <button @click.prevent="$emit('resetBallot')" class="btn btn-danger" data-bs-dismiss="modal">
            {{ $t("js.actions.reset") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ResetModal",
  props: {
    id: {
      type: String,
      default: "resetModal",
    },
  },
});
</script>
